/* eslint-disable init-declarations, react/jsx-no-bind */

import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap-modal";
import PropTypes from "prop-types";
import {connect} from "react-redux";

const NotificationModal = (props) => {
  const {displayNewTierNotification} = props;

  const [
    newTierName,
    setNewTierName
  ] = useState(displayNewTierNotification);

  let imgSrc;

  useEffect(() => {
    setNewTierName(displayNewTierNotification);
  }, [displayNewTierNotification]);

  const handleHideModal = () => {
    setNewTierName(false);
  };

  if (newTierName) {
    const imageUrlPrefix = "https://karat-herokuapp-com.freetls.fastly.net/s3media";
    const tierName = newTierName.toLowerCase().replace(" ", "");
    imgSrc = `${imageUrlPrefix}/site/newbrand-banner/rewards/modals/rewards-modal-${tierName}.gif`;
  }

  return (
    <Modal
      className="tier-notification-modal"
      onHide={handleHideModal}
      show={Boolean(newTierName)}
    >
      <Modal.Body>
        <a href="/rewards">
          <img src={imgSrc} />
        </a>
      </Modal.Body>
    </Modal>
  );
};

NotificationModal.propTypes = {
  "displayNewTierNotification": PropTypes.oneOfType(
    [
      PropTypes.bool,
      PropTypes.string
    ]
  ).isRequired
};

const mapStateToProps = state => ({"displayNewTierNotification": state.displayNewTierNotification});

export default connect(mapStateToProps)(NotificationModal);
